import { styled } from '@mui/material/styles'
import CustomModal from '../modal/Modal'

export const Modal = styled(CustomModal)({
  '.MuiBox-root': {
    maxWidth: 1024,
    width: 'calc(100% - 32px)',
  },
  '#vehicleMap-title': {
    display: 'flex',
    alignItems: 'center',
    fontSize: 19,
    'img': {
      filter: 'invert(1)',
      marginRight: 16,
      width: 36,
      height: 36,
    },
  },
})
